module.exports = __webpack_public_path__ + "static/media/stretcher.b55bb748.svg";